import React from 'react';
import { Hero } from './components/Hero';
import { Opportunity } from './components/Opportunity';
import { Styles } from './components/Styles';
import { ManualSection } from './components/ManualSection';
import { Bonuses } from './components/Bonuses';
import { Steps } from './components/Steps';
import { GalleryStrip } from './components/GalleryStrip';
import { Testimonials } from './components/Testimonials';
import { OfferCard } from './components/OfferCard';
import { SiteFooter } from './components/SiteFooter';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { useCountdown } from './hooks/useCountdown';
interface AppProps {
  /** Muestra la barra y el contador de oferta por tiempo limitado. */
  showCountdown?: boolean;
  /** Muestra las notificaciones de compras recientes. */
  showPurchasePopup?: boolean;
}
export function App({
  showCountdown = true,
  showPurchasePopup = true
}: AppProps) {
  const countdown = useCountdown(30);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3ij668fcdfvai">
      <MetaPixel data-id="element-1" data-mp="3mlaxx8j9ehui" />
      {showPurchasePopup ? <PurchasePopup data-id="element-2" data-mp="3mk85gw6ag7ch" /> : null}
      <Hero countdown={countdown} showCountdown={showCountdown} data-id="element-3" data-mp="3mjg8pi0yg3km" />
      <main data-id="element-4" data-mp="3rdkgg3i1ofmr">
        <Opportunity data-id="element-5" data-mp="3rcsuzli5vya7" />
        <Styles data-id="element-6" data-mp="3relu8fqg3g86" />
        <ManualSection data-id="element-7" data-mp="5otf64sd496" />
        <Bonuses data-id="element-8" data-mp="682dxcgkib2" />
        <Steps data-id="element-9" data-mp="4n7g6m8exco" />
        <GalleryStrip data-id="element-10" data-mp="56l3b4umzkw" />
        <Testimonials data-id="element-11" data-mp="2zl3a7gleoy37" />
        <OfferCard showCountdown={showCountdown} countdown={countdown} data-id="element-12" data-mp="2zllcouynw8jk" />
      </main>
      <SiteFooter data-id="element-13" data-mp="33mf25srr5vek" />
    </div>;
}